




























































































































import 'reflect-metadata'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import { IDataTableTransferPlanning } from "@/resource/planning-cr/ModifyJsonData"
import DeedCustomerData from '@/components/planning-cr/deed/DeedCustomerData.vue'   
import DeedCustomerSearch from '@/components/planning-cr/deed/DeedCustomerSearch.vue'   
import DeedDialogRemove from "@/components/planning-cr/deed/DeedDialogRemove.vue"  

import { DeedCustomerApi } from "@/api"

@Component({
    components: { 
        DeedCustomerSearch,
        DeedCustomerData,
        DeedDialogRemove
    }
})
export default class DeedDialog extends Vue { 
    @Prop(Function) public UpdateDeedNameByUnitId: any
    @Prop(Function) public notifcation: any

    panelCUstomerSearch = 1
    panelCustomerData = 1

    dialogBank = false

    loading = false
    unitId = null as any
    unitCode = "" 
    bookingId = null as any
    headers = [
        { text: 'No.', value: 'no', sortable: false, width: 20  },
        { text: 'ชื่อลูกค้า', value: 'customerName', sortable: false  },
        { text: '', value: 'actions', sortable: false, align: 'right'},
    ]
    deedProspectLists = [
        { no: 1, customerName: "", prospectId: 0 },
        { no: 2, customerName: "", prospectId: 0 },
        { no: 3, customerName: "", prospectId: 0 },
        { no: 4, customerName: "", prospectId: 0 }
    ] as any[]
    openDialogRemove = false
    masterTitle = null

    async getDeedProspect (bookingId: number) {
        this.loading = true
        const deedProspect = await DeedCustomerApi.GetDeedProspectByBookingId(bookingId)
        this.deedProspectLists = [
            { no: 1, customerName: deedProspect[0].deedProspectName1, prospectId: deedProspect[0].deedProspectId1 },
            { no: 2, customerName: deedProspect[0].deedProspectName2, prospectId: deedProspect[0].deedProspectId2 },
            { no: 3, customerName: deedProspect[0].deedProspectName3, prospectId: deedProspect[0].deedProspectId3 },
            { no: 4, customerName: deedProspect[0].deedProspectName4, prospectId: deedProspect[0].deedProspectId4 },
        ]
        this.loading = false
        return this.deedProspectLists
    }

    async OpenDialog (item: IDataTableTransferPlanning) {
        this.loading = true
        this.dialogBank = true
        this.unitId = item.unitId
        this.unitCode = item.unitCode
        this.bookingId = item.bookingId
        await this.getDeedProspect(item.bookingId)
        this.panelCustomerData = 1
        this.loading = false
    }

    async BtnSelectedDeedProspect (item: any) {
        this.panelCustomerData = 0
        const prospectDetail = await DeedCustomerApi.GetDeedProspectDetailByProspectId(item.prospectId)
        console.log("prospectDetail :")
        console.log(prospectDetail)

        const refDeedCustomerData = this.$refs.refDeedCustomerData as DeedCustomerData
        refDeedCustomerData.setTextBox(prospectDetail)
    }

    async BtnRemoveDeedProspect (item: any) {
        const refDialogRemove = this.$refs.deedDialogRemove as any
        const deedProspect = this.deedProspectLists
        refDialogRemove.openDialog(this.bookingId, this.unitId, deedProspect, item)
    }

    openLoading (status: boolean) {
        this.loading = status
    }

    openPanelCustomerData (status: boolean) {
        this.panelCustomerData = status === true ? 0 : 1
    }

    closeDialog () {
        this.dialogBank = false
    }

}
